import { NgModule } from '@angular/core';
import {CommonModule, CurrencyPipe, DatePipe} from '@angular/common';
import { CompanyEventsComponent } from "./company-events.component";
import { CompanyEventsInformationComponent } from './company-events-subcomponents/company-events-information/company-events-information.component';
import { CompanyEventsToolbarComponent } from './company-events-subcomponents/company-events-toolbar/company-events-toolbar.component';
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CompanyEventsCalendarComponent } from "./company-events-calendar/company-events-calendar.component";
import { FullCalendarModule } from "@fullcalendar/angular";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDividerModule } from "@angular/material/divider";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { CompanyEventsSearchComponent } from './company-events-subcomponents/company-events-search/company-events-search.component';
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { CompanyEventsLinksComponent } from './company-events-subcomponents/company-events-links/company-events-links.component';
import { CompanyEventsNotesComponent } from './company-events-subcomponents/company-events-notes/company-events-notes.component';
import { CompanyEventsAttendeesComponent } from './company-events-subcomponents/company-events-attendees/company-events-attendees.component';
import { CompanyEventsOutlookComponent } from './company-events-subcomponents/company-events-outlook/company-events-outlook.component';
import {MatSelectModule} from "@angular/material/select";
import {MatRadioModule} from "@angular/material/radio";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatTableModule} from "@angular/material/table";
import {MatListModule} from "@angular/material/list";
import { CompanyEventsAttendeeTileComponent } from './company-events-subcomponents/company-events-attendees/company-events-attendee-tile/company-events-attendee-tile.component';
import {Clipboard, ClipboardModule} from "@angular/cdk/clipboard";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import { CompanyEventsListComponent } from './company-events-list/company-events-list.component';
import { CompanyEventsListTileComponent } from './company-events-list/company-events-list-subcomponents/company-events-list-tile/company-events-list-tile.component';
import {PipesModule} from "../pipes/pipes.module";
@NgModule({
  declarations: [
    CompanyEventsComponent,
    CompanyEventsInformationComponent,
    CompanyEventsToolbarComponent,
    CompanyEventsCalendarComponent,
    CompanyEventsSearchComponent,
    CompanyEventsLinksComponent,
    CompanyEventsNotesComponent,
    CompanyEventsAttendeesComponent,
    CompanyEventsOutlookComponent,
    CompanyEventsAttendeeTileComponent,
    CompanyEventsListComponent,
    CompanyEventsListTileComponent,
  ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatTableModule,
        MatListModule,
        MatSlideToggleModule,
        MatTooltipModule,
        FullCalendarModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDividerModule,
        FormsModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatRadioModule,
        MatDatepickerModule,
        PipesModule
    ],
  providers: [
    DatePipe,
    CurrencyPipe,
    Clipboard
  ]
})

export class CompanyEventsModule {}
